var Matches = require('./Matches');
/**
 * Escapes a string to be used within a RegExp
 *
 * @param  {String} string
 * @return {String}
 */


function escapeRegExp(string) {
  return string.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}

function _toArray(object) {
  return Array.prototype.slice.call(object);
}

function Saw(object) {
  if (Array.isArray(object)) {
    this._context = object.slice(0);
  } else if (object instanceof Matches) {
    this._context = object.clone();
  } else {
    this._context = object;
  }
}

function argumentsToArray(args) {
  var result;

  if (args.length > 1) {
    result = _toArray(args);
  } else if (Array.isArray(args[0])) {
    result = args[0];
  } else {
    result = [args[0]];
  }

  return result;
}

Saw.prototype = {
  match: function match(_match) {
    var matchArray = argumentsToArray(arguments),
        saw = new Saw(this._context),
        context = this._contextToString(this._context);

    matchArray.some(function (match) {
      var matches = typeof match === 'function' ? match(context) : context.match(match);

      if (!matches) {
        saw._context = '';
      } else {
        saw._context = new Matches(matches, match);
        return true;
      }
    });
    return saw;
  },
  has: function has(match) {
    return this.match(match).first().toBoolean();
  },
  item: function item(index) {
    var saw = new Saw(this._context);

    if (saw._context instanceof Matches) {
      saw._context = saw._context.item(index);
    } else if (Array.isArray(saw._context)) {
      saw._context = saw._context[index] || '';
    }

    return saw;
  },
  itemFromRight: function itemFromRight(index) {
    var saw = new Saw(this._context);

    if (saw._context instanceof Matches || Array.isArray(saw._context)) {
      var length = saw._context.length;
      index = length - 1 - index;

      if (index >= 0) {
        saw = saw.item(index);
      }
    }

    return saw;
  },
  first: function first(index) {
    var saw = new Saw(this._context);
    return saw.item(0);
  },
  last: function last() {
    var saw = new Saw(this._context);
    return saw.itemFromRight(0);
  },
  replace: function replace(match, replacement) {
    var saw = new Saw(this._context);

    if (Array.isArray(saw._context)) {
      saw._context = saw._context.map(function (string) {
        return string.replace(match, replacement);
      });
    } else {
      saw._context = this._contextToString(this._context).replace(match, replacement);
    }

    return saw;
  },
  join: function join(separator) {
    var saw = new Saw(this._context);

    if (Array.isArray(saw._context)) {
      var result = '';

      saw._context.forEach(function (item, index, array) {
        var currentSeparator = typeof separator == 'function' ? separator(item, index, array) : separator || '';
        result += item + (array.length - 1 == index ? '' : currentSeparator);
      });

      saw._context = result;
    }

    return saw;
  },
  each: function each(func, thisArg) {
    var saw = new Saw(this._context); // Note: adds array as a third param

    var array = saw.toArray();
    array.forEach(function (item, index) {
      if (item) {
        func.bind(thisArg)(item, index, array);
      }
    });
    return saw;
  },
  map: function map(func, thisArg) {
    var saw = new Saw(this._context); // Note: adds array as a third param

    var array = saw.toArray();
    saw._context = array.map(function (item, index) {
      return func.bind(thisArg)(item, index, array);
    });
    return saw;
  },
  reduce: function reduce(func, thisArg) {
    var saw = new Saw(this._context); // Note: adds array as a third param

    var array = saw.toArray();
    saw._context = String(array.reduce(function (previousValue, currentValue, index, array) {
      return func.bind(thisArg)(previousValue, currentValue, index, array);
    }));
    return saw;
  },
  reverse: function reverse() {
    var saw = new Saw(this._context);

    if (typeof saw._context === 'string') {
      saw._context = saw._context.split('').reverse().join('');
    } else if (Array.isArray(saw._context)) {
      saw._context = saw._context.reverse();
    } else if (saw._context instanceof Matches) {
      var array = saw.toArray();

      if (array.length === 1) {
        saw._context = (array[0] || '').split('').reverse().join('');
      } else {
        saw._context = saw.toArray().reverse();
      }
    }

    return saw;
  },
  lowerCase: function lowerCase(func) {
    return this.mapStringMethodAgainstContext('toLowerCase', func);
  },
  upperCase: function upperCase(func) {
    return this.mapStringMethodAgainstContext('toUpperCase', func);
  },
  mapStringMethodAgainstContext: function mapStringMethodAgainstContext(methodName, func) {
    var saw = new Saw(this._context); // Note: adds array as a third param

    var array = saw.toArray();
    saw._context = array.map(function (item, index) {
      return item ? String(item)[methodName]() : item;
    });
    return saw;
  },
  filter: function filter(match, thisArg) {
    var saw = new Saw(this._context); // default filter

    match = match || function (item) {
      return item;
    }; // Note: adds array as a third param


    var array = saw.toArray();
    saw._context = array.filter(function (item, index) {
      if (typeof match === 'function') {
        return match.bind(thisArg)(item, index, array);
      } else {
        return item.match(match);
      }
    });
    return saw;
  },
  remove: function remove() {
    var saw = new Saw(this._context);

    var context = saw.toArray(),
        matches = _toArray(arguments);

    context = context.map(function (context) {
      matches.forEach(function (match) {
        match = typeof match === 'string' ? new RegExp(escapeRegExp(match), 'g') : match;
        context = context.replace(match, '');
      });
      return context;
    });
    saw._context = context;
    return saw;
  },
  trim: function trim() {
    var saw = new Saw(this._context);
    var context = Array.isArray(saw._context) ? saw._context : saw.toArray(saw._context);
    saw._context = context.map(function (item) {
      return item ? item.trim() : item;
    });
    return saw;
  },
  split: function split(separator) {
    var saw = new Saw(this._context);
    saw._context = saw._contextToString(saw._context).split(separator);
    return saw;
  },
  slice: function slice(begin, end) {
    var saw = new Saw(this._context);
    saw._context = saw._context.slice(begin, end);
    return saw;
  },
  toString: function toString() {
    return this._contextToString(this._context);
  },
  toArray: function toArray() {
    if (Array.isArray(this._context)) {
      return _toArray(this._context);
    } else if (this._context instanceof Matches) {
      return this._context.toArray();
    } else {
      return this.toBoolean() ? [this._context] : [];
    }
  },
  toNumber: function toNumber() {
    var result = this.toFloat();
    return isNaN(result) ? 0 : result;
  },
  toFloat: function toFloat() {
    var string = this.trim().toString(),
        result = parseFloat(string, 10);

    if (isNaN(result) || string.length != String(result).length) {
      return NaN;
    } else {
      return result;
    }
  },
  toInt: function toInt() {
    var string = this.trim().toString(),
        result = parseInt(string, 10);

    if (isNaN(result) || string.length != String(result).length) {
      return NaN;
    } else {
      return result;
    }
  },
  toBoolean: function toBoolean() {
    return !!this.toString();
  },
  toObject: function toObject() {
    var props = argumentsToArray(arguments),
        array = this.toArray(),
        object = {};
    props.forEach(function (value, index) {
      if (typeof value !== 'undefined' && typeof array[index] != 'undefined') {
        object[value] = array[index];
      }
    });
    return object;
  },
  indexOf: function indexOf(match) {
    var saw = new Saw(this._context),
        index = this.indexesOf(match).shift();
    return typeof index !== 'undefined' ? index : -1;
  },
  indexesOf: function indexesOf(match) {
    var saw = new Saw(this._context),
        indexes = [];

    if (Array.isArray(this._context)) {
      this._context.forEach(function (item, i) {
        if (String(item).match(match) || typeof match === 'function' && match(item)) {
          indexes.push(i);
        }
      });
    } else if (typeof this._context === 'string') {
      var pattern = new RegExp(match instanceof RegExp ? match.source : escapeRegExp(match), match instanceof RegExp ? String(match.flags).match(/g/) ? match.flags || '' : (match.flags || '') + 'g' : 'g');

      while (match = pattern.exec(this._context)) {
        indexes.push(match.index);
      }
    }

    return indexes;
  },
  length: function length() {
    if (!this._context) {
      return 0;
    } else {
      return this._context.length;
    }
  },
  _contextToString: function _contextToString(context) {
    if (typeof context === 'string') {
      return context;
    } else if (context instanceof Matches) {
      return context.toString();
    } else if (Array.isArray(context)) {
      return context.join('');
    }

    return '';
  }
};
module.exports = Saw;